import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';


function WidgetAlertbox(message, title = "Attention", btn = true) {
  const [open, setOpen] = React.useState(false);
  const [callback, setCallback] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleOpen = (f, t = true) => { setOpen(t); (t ? setCallback(() => f) : f()); };

  return [(
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {btn &&
            <>
              <Button onClick={() => { callback(); handleClose(); }}>Continuer</Button>
              <Button onClick={() => { handleClose(); }} autoFocus>Annuler</Button>
            </>
          }
          {/* {!btn &&
            <Button onClick={() => { handleClose(); }} autoFocus>Fermer</Button>
          } */}
        </DialogActions>
      </Dialog>
    </>
  ), handleOpen];
}

export default WidgetAlertbox;